<template>
  <div class="wrapper">
    <div class="top">
      <div class="box">
        <textarea
          name
          v-model="message"
          style="resize: none"
          class="textarea1"
          rows="2"
          placeholder="请粘贴例如：张三，13200000000，浙江省杭州市西湖区某某大厦001号(请注明省市区县)"
        ></textarea>
      </div>
      <span :class="message != '' ? 'box1' : 'box2'" @click="readFile"
        >识别</span
      >
    </div>
    <van-cell-group class="content">
      <van-field
        clearable
        label="收货人"
        placeholder="请填写收货人姓名"
        v-model="name"
      />
      <van-field
        type="number"
        label="手机号"
        placeholder="请填写您的手机号"
        v-model="telephone"
        maxlength="11"
      />
      <van-cell
        title="所在地区"
        is-link
        :value="
          province && city && area
            ? province + '-' + city + '-' + area
            : '请选择地区'
        "
        @click="show = true"
      />
      <van-field
        type="textarea"
        label="详细地址"
        placeholder="请填写详细地址"
        row="2"
        class="textarea"
        v-model="detail"
      />
    </van-cell-group>
    <van-row class="default" type="flex" justify="space-between" align="center">
      <span>设为默认地址</span>
      <van-switch active-color="#4CD964" v-model="checked" @change="slip" />
    </van-row>
    <van-row v-if="identityNumShow" class="identityDes">
      *因海淘商品需要提交身份信息供海关审核，身份信息已加密处理
    </van-row>
    <van-field
      v-if="identityNumShow"
      type="text"
      label="身份证"
      placeholder="请输入身份证号码 加密处理 清关需要"
      v-model="identity"
      maxlength="18"
      @focus="toBottom"
    />
    <div class="identityArea" v-if="identityImgShow">
      <div class="title">上传身份证照片</div>
      <div class="des">
        <img src="./../../assets/images/notice.png" alt="" />
        <div class="right">
          温馨提示：请上传原始比例的身份证正反面，请勿剪切涂改，保证身份信息清晰显示，否则无法通过审核。
        </div>
      </div>
      <div class="photoArea">
        <van-uploader
          :after-read="upload1"
          accept="image/*"
          :before-read="beforeRead"
          class="photoItem"
        >
          <div class="photoCenter" v-if="facePhoto">
            <img class="img" :src="facePhoto" alt="" />
          </div>
          <div class="photoCenter" v-else>
            <img class="icon" src="./../../assets/images/camera.png" alt="" />
            <span>正面照片</span>
          </div>
        </van-uploader>
        <van-uploader
          :after-read="upload2"
          accept="image/*"
          :before-read="beforeRead"
          class="photoItem"
        >
          <div class="photoCenter" v-if="backPhoto">
            <img class="img" :src="backPhoto" alt="" />
          </div>
          <div class="photoCenter" v-else>
            <img class="icon" src="./../../assets/images/camera.png" alt="" />
            <span>反面照片</span>
          </div>
        </van-uploader>
      </div>
    </div>
    <van-row
      v-if="this.$route.query.nbr"
      class="delete"
      type="flex"
      justify="space-between"
      align="center"
      @click.native="show1 = true"
    >
      <span>删除收货地址</span>
    </van-row>
    <van-row v-if="!identityNumShow" class="identityDes">
      <span>*若需购买海购商品，请先完善身份信息</span>
      <div
        class="showIdentity"
        @click="
          identityNumShow = true;
          identityImgShow = true;
        "
      >
        <span>立即完善</span>
      </div>
    </van-row>
    <!--<van-row class="select" @click.native="is_default = !is_default">-->
    <!--<img :src="is_default?require('./../../assets/images/icon_xuanzhong.png'):require('./../../assets/images/icon_weixuan.svg')" alt="">默认地址-->
    <!--</van-row>-->
    <van-row class="bottom">
      <van-button type="danger" round class="btn" @click.native="save"
        >保存</van-button
      >
    </van-row>
    <!--三级联动-->
    <van-popup class="suoyin" v-model="show" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="confirm"
        :value="areaCode"
        @cancel="show = false"
      />
    </van-popup>
    <van-popup v-model="show1" style="border-radius: 0.18rem">
      <div class="showbox">
        <div class="top">
          <span>确认要删除该地址吗？</span>
        </div>
        <div class="bottom2">
          <span @click="show1 = false">取消</span>
          <span @click="goprevious">删除</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import areaList from "./../../assets/js/area";
import {
  checkidentificationcard,
  checkphone,
  checkempty,
  photoCompress,
  dataURLtoFile,
  handleText,
  handleText_anti,
} from "./../../assets/js/tool";
import OSS from "ali-oss";
import ObsClient from "esdk-obs-browserjs/src/obs";
import { mapGetters } from "vuex";
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      s: 0,
      show: false,
      show1: false,
      checked: false,
      areaList: areaList,
      areaCode: "",
      id: 0, //修改地址就会有id;
      name: "",
      telephone: "",
      is_default: 0,
      default: 0,
      province: "",
      city: "",
      area: "",
      detail: "",
      message: "", //识别地址
      data: "",
      identity: "",
      facePhoto: "",
      backPhoto: "",
      identityNumShow: false,
      identityImgShow: false,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["selectaddress"]),
  },
  methods: {
    toBottom() {
      window.scrollTo(0, 1000);
    },
    slip() {
      this.checked == !this.checked;
      if (this.checked) {
        this.default = "1";
      } else {
        this.default = "0";
      }
    },
    goprevious() {
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_10011",
          nbr: this.$route.query.nbr,
          user_nbr: this.userInfo.nbr,
        },
      })
        .then((response) => {
          if (this.selectaddress.nbr == this.$route.query.nbr) {
            this.$store.commit("SENDselectaddress", "");
          }
          this.$toast({
            message: "删除成功！",
            duration: 2000,
          });
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
          this.show1 = false;
        });
    },
    readFile() {
      let message = this.message;
      if (this.message == " ") {
        this.$toast({
          message: "请填写正确的可识别地址！",
          duration: 2000,
        });
        return;
      }
      if (this.message == "undefined") {
        this.$toast({
          message: "未获取到地址！",
          duration: 2000,
        });
        return;
      }
      if (this.province == " ") {
        this.province = " ";
      }
      if (this.city == " ") {
        this.city = " ";
      }
      if (this.area == " ") {
        this.area = " ";
      }
      this.$post("/api/customer/parseAddress", {
        userNbr: this.userInfo.nbr,
        addressInfo: message,
      }).then((data) => {
        console.log(data);
        if (data.code == "200") {
          let resp = data.object.resp;
          if (resp.resp_code == "0" && resp.resp_result == "0") {
            this.name = resp.address.contact;
            this.telephone = resp.address.phoneNo;
            this.province = resp.address.province;
            this.city = resp.address.city;
            this.area = resp.address.district;
            this.detail = resp.address.address;
            this.checkAddress();
          } else {
            this.$toast({
              message: resp.resp_msg,
            });
          }
        } else {
          this.$toast({
            message: resp.resp_msg,
          });
        }
      });
    },
    confirm(e) {
      this.province = e[0].name;
      this.city = e[1].name;
      this.area = e[2].name;
      this.show = false;
    },
    save() {
      const that = this;
      const arr = [
        { val: that.name, toast: "请输入名字" },
        { val: that.telephone },
        { val: that.province, toast: "请选择地区" },
        { val: that.detail, toast: "请输入详细地址" },
      ];
      let result = true;
      for (var index = 0; index < arr.length; index++) {
        if (index === 1 && !checkphone(arr[index].val)) {
          result = false;
          break;
        } else if (!checkempty(arr[index].val, arr[index].toast)) {
          result = false;
          break;
        }
      }
      if (!result) {
        return;
      }
      let type = 1;
      if (
        !checkempty(this.identity) &&
        !checkempty(this.facePhoto) &&
        !checkempty(this.backPhoto)
      ) {
        type = 1;
      } else if (
        checkempty(this.identity) &&
        checkidentificationcard(this.identity) &&
        !checkempty(this.facePhoto) &&
        !checkempty(this.backPhoto)
      ) {
        type = 2;
      } else if (
        checkempty(this.identity) &&
        checkidentificationcard(this.identity) &&
        checkempty(this.facePhoto) &&
        checkempty(this.backPhoto)
      ) {
        type = 3;
      } else {
        return this.$toast({
          message: "请完善身份信息",
          duration: 2000,
        });
      }

      let data = {
        type: type,
        uid: that.userInfo.nbr,
        province: that.province,
        city: that.city,
        district: that.area,
        address: handleText_anti(that.detail),
        phone_no: that.telephone,
        contacts: that.name,
        is_default: that.default,
        identity: that.identity,
        identity_face_photo: that.facePhoto,
        identity_back_photo: that.backPhoto,
      };
      if (this.nbr) {
        data.sub_flow = "flow_10007";
        data.nbr = this.nbr;
      } else {
        data.sub_flow = "flow_10005";
      }
      let params = { jydm: "flow_10000", flow_10000: data };
      // 加载框子
      const toast = this.$toast({
        type: "loading",
        message: "保存中...",
        duration: 0,
        mask: true,
      });

      this.$post("/api/customer/checkAddressIdent", {
          mos: params,
        })
        .then((res) => {
          if (res.code == "200") {
            let resp = res.object.resp;
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              toast.clear();
              if (
                this.$route.query.nbr &&
                this.selectaddress.nbr == this.$route.query.nbr
              ) {
                this.$store.commit("SENDselectaddress", data);
              }
              this.$toast({
                message: "保存成功！",
                duration: 2000,
              });
              that.$router.go(-1);
            } else {
              this.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
          } else {
            this.$toast({
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    beforeRead(file) {
      if (
        file.type == "image/jpeg" ||
        file.type == "image/jpg" ||
        file.type == "image/png"
      ) {
        return true;
      } else {
        this.$toast({ message: `请上传图片格式为jpg，jpeg，png！` });
        return false;
      }
    },
    upload1(file) {
      this.upload("face", file);
    },
    upload2(file) {
      this.upload("back", file);
    },
    upload(type, file) {
      const that = this;
      let toast = this.$toast.loading({
        duration: 0,
      });
      let quality = Number((1048576 / file.file.size).toFixed(1)); //压缩到1m以内  算出压缩比例
      photoCompress(file.file, callback, quality); //将图片进行压缩
      function callback(res) {
        let newFile = dataURLtoFile(res, file.file.name);
        let url = that.uploadPath("images/user", newFile);
        if(that.uplaodServer=='aliyun'){
          that.$post("/api/customer/getOSSToken", {
            userNbr: that.userInfo.nbr,
            token: "123456",
          })
          .then((data) => {
            let OSSToken = data.object.resp;
            if (OSSToken.resp_code == 0 && OSSToken.resp_result == 0) {
              let client = new OSS({
                //            region: '购买的区域',
                endpoint: OSSToken.endpoint,
                bucket: OSSToken.bucketName,
                accessKeyId: OSSToken.accessKeyId,
                accessKeySecret: OSSToken.accessKeySecret,
                stsToken: OSSToken.securityToken,
              });
              client.options.endpoint.protocol = "https:";
              client
                .put(url, newFile)
                .then((data) => {
                  let imgUrl = that.cdnImgPath + "/" + data.name;
                  that[`${type}Photo`] = imgUrl;
                  that.$forceUpdate();
                  toast.clear();
                })
                .catch((error) => {
                  toast.clear();
                  that.$toast({
                    message: "上传失败",
                    duration: 2000,
                  });
                });
            } else {
              that.$toast({
                message: OSSToken.resp_msg,
                duration: 2000,
              });
            }
          })
          .catch((err) => {
            that.$toast({
              message: err.message,
              duration: 2000,
            });
          });
        }else{
          that.$post("/api/customer/getObsToken", {
            userNbr: that.userInfo.nbr,
            token: "123456",
          })
          .then((data) => {
            let OBSToken = data.object.resp;
            if (OBSToken.resp_code == 0 && OBSToken.resp_result == 0) {
              let client = new ObsClient({
                access_key_id: OBSToken.accessKeyId,
                secret_access_key: OBSToken.accessKeySecret,
                server: OBSToken.endpoint,
                security_token: OBSToken.securityToken,
                timeout: 3000, // 设置超时时间
              });
              client.putObject(
                {
                  Bucket: OBSToken.bucketName, // 桶名
                  Key: url, // 文件名
                  SourceFile: newFile,
                },
                function (err, result) {
                  if (err) {
                    toast.clear();
                    that.$toast({
                      message: "上传失败",
                      duration: 2000,
                    });
                  } else {
                    if (result.CommonMsg.Status < 300) {
                      let imgUrl = that.cdnImgPath + "/" + url;
                      that[`${type}Photo`] = imgUrl;
                      that.$forceUpdate();
                      toast.clear();
                    }
                  }
                }
              );
            } else {
              that.$toast({
                message: OBSToken.resp_msg,
                duration: 2000,
              });
            }
          })
          .catch((err) => {
            that.$toast({
              message: err.message,
              duration: 2000,
            });
          });
        }
      }
    },
    uploadPath(path, file) {
      let name = file.name.replace("wxfile://", "");
      let random = Math.round(Math.random() * 100000);
      // ${name.split(".")[0]}
      return `${path}/${this.userInfo.nbr}-${new Date().getTime()}.${
        file.type.split("/")[1]
      }`;
    },
    getData() {
      this.$commonPost({
        jydm: "flow_10009",
        flow_10009: {
          nbr: this.nbr,
        },
      })
        .then((response) => {
          this.name = response.contacts;
          this.telephone = response.phone_no;
          this.province = response.province;
          this.city = response.city;
          this.area = response.district;
          this.detail = handleText(response.address);
          this.is_default = response.is_default;
          this.identity = response.identity || "";
          this.backPhoto = response.identity_back_photo || "";
          this.facePhoto = response.identity_face_photo || "";
          if (this.is_default == 1) {
            this.checked = true;
          }
          if (response.type > 1) {
            this.identityNumShow = true;
            this.identityImgShow = true;
          }
          this.checkAddress();
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    checkAddress() {
      let areaList = this.areaList;
      let code = "";
      if (this.province) {
        for (let key in areaList.province_list) {
          if (this.province == areaList.province_list[key]) {
            code = key;
            break;
          }
        }
      }
      if (this.city) {
        let provinceNum = parseInt(parseInt(code) / 10000);
        for (let key in areaList.city_list) {
          if (
            provinceNum == parseInt(parseInt(key) / 10000) &&
            this.city == areaList.city_list[key]
          ) {
            code = key;
            break;
          }
        }
      }
      if (this.area) {
        let cityNum = parseInt(parseInt(code) / 100);
        for (let key in areaList.county_list) {
          if (
            cityNum == parseInt(parseInt(key) / 100) &&
            this.area == areaList.county_list[key]
          ) {
            code = key;
            break;
          }
        }
      }
      this.areaCode = code;
    },
    initPage() {
      if (this.$route.query.nbr) {
        if (this.$route.query.supNbr == this.userInfo.nbr) {
          this.getData();
        } else {
          return this.$router.push({
            path: "index",
            query: { supNbr: this.userInfo.nbr },
          });
        }
      }
      let showType = this.$route.query.showType;
      if (showType == 2) {
        this.identityNumShow = true;
      } else if (showType == 3) {
        this.identityNumShow = true;
        this.identityImgShow = true;
      }
      let option = {
        title: "有米@" + this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl,
      };
      this.weChatShare(option);
    },
  },
  created() {
    if (!this.$route.query.nbr) {
      document.title = "添加地址";
    } else {
      document.title = "修改地址";
      this.nbr = this.$route.query.nbr || "";
    }
    this.initPage();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
<style scoped lang='stylus'>
.content >>> .van-field .van-cell__title {
  max-width: 1.8rem;
}

.content >>> .van-field__control {
  color: #333333;
}

.content >>> .van-cell--clickable .van-cell__title {
  max-width: 1.8rem;
}

.content >>> .van-cell--clickable .van-cell__value {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  color: #333333;
}

.content >>> .van-icon, .van-icon::before {
  font-size: 0.32rem;
  line-height: 0.56rem;
}

.default >>> .van-switch {
  width: 0.88rem;
  height: 0.5rem;
}

.default >>> .van-switch--on .van-switch__node {
  transform: translateX(0.4rem);
}

.default >>> .van-switch__node {
  width: 0.46rem;
  height: 0.46rem;
  top: 0.02rem;
}
</style>
<style scoped lang='less'>
.wrapper {
  width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
  padding-bottom: 4rem;
  box-sizing: border-box;
}
.content {
  .van-cell {
    padding: 0.2rem 0.3rem;
    font-size: 0.28rem;
    line-height: 0.56rem;
    height: 0.96rem;
    box-sizing: border-box;
  }
  .textarea {
    height: auto;
  }
}
.identityDes {
  font-size: 0.22rem;
  padding-left: 0.22rem;
  box-sizing: border-box;
  color: #e52b25;
  font-weight: 500;
  margin: 0.24rem 0;
  width: 100%;
  position: relative;
  line-height: 0.3rem;
  .showIdentity {
    width: 1.28rem;
    height: 0.44rem;
    border: 1px solid #e52b25;
    border-radius: 0.22rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0.24rem;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      line-height: 0;
      font-size: 0.24rem;
    }
  }
}
.identityArea {
  width: 100%;
  background: #fff;
  margin-top: 0.2rem;
  .title {
    font-size: 0.3rem;
    color: #333;
    font-weight: 500;
    padding-left: 0.3rem;
    height: 0.88rem;
    display: flex;
    line-height: 0.88rem;
    align-items: center;
  }
  .des {
    height: 0.8rem;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    img {
      width: 0.24rem;
      height: 0.24rem;
    }
    .right {
      width: 6.54rem;
      line-height: 0.3rem;
      font-size: 0.22rem;
      color: #999;
      font-weight: 500;
      margin-left: 0.12rem;
    }
  }
  .photoArea {
    height: 2.58rem;
    width: 100%;
    display: flex;
    .photoItem {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .photoCenter {
        width: 3.24rem;
        height: 2rem;
        border: 1px dashed #979797;
        border-radius: 0.04rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .img {
          width: 100%;
          height: 100%;
          background: #ccc;
        }
        .icon {
          width: 0.8rem;
          height: 0.8rem;
          margin-bottom: 0.2rem;
          margin-top: 0.38rem;
        }
        span {
          font-size: 0.26rem;
          line-height: 0.31rem;
          color: #333;
          font-weight: 500;
        }
      }
    }
  }
}
.select {
  margin: 0.28rem;
  font-size: 0.24rem;
  color: #666666;
  img {
    width: 0.4rem;
    height: 0.4rem;
    margin-right: 0.08rem;
  }
}
.default {
  background: #ffffff;
  margin-top: 0.2rem;
  height: 0.88rem;
  padding: 0 0.24rem;
}
.delete {
  background: #ffffff;
  height: 0.88rem;
  font-size: 0.28rem;
  color: #e52b25;
  margin-top: 0.2rem;
  padding: 0 0.24rem;
}
.bottom {
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  padding: 0.1rem 0.28rem;
  background: #ffffff;
  .btn {
    width: 100%;
    font-size: 0.32rem;
  }
  .van-button--danger {
    color: #fff;
    background: #e52b25;
    border: 1px solid #e52b25;
  }
}
.showbox {
  width: 6.14rem;
  height: 3.04rem;
  background: #ffffff;
  .top {
    height: 1.95rem;
    font-size: 0.3rem;
    color: #333333;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bottom2 {
    border-top: 1px solid #eeeeee;
    height: 1.07rem;
    display: flex;
    span {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      font-size: 0.3rem;
    }
    span:first-of-type {
      color: #333333;
      border-right: 1px solid #eeeeee;
    }
    span:last-of-type {
      color: #e52b25;
    }
  }
}
.top {
  width: 100%;
  height: 1.4rem;
  background: #ffffff;
  position: relative;
  .box {
    width: 5.83rem;
    font-family: PingFang-SC-Medium;
    font-size: 0.28rem;
    color: #333333;
    display: inline-block;
    word-break: break-all;
    margin-left: 0.3rem;
    margin-top: 0.3rem;
    .textarea1 {
      width: 100%;
      line-height: 0.34rem;
      overflow: hidden;
      border: none;
      color: #333333;
    }
    .textarea1 textarea::-webkit-input-placeholder {
      color: #cccccc;
    }
  }
  .box::after {
    border: 0 !important;
  }
  .box1 {
    width: 0.9rem;
    height: 0.4rem;
    background: #e52b25;
    border-radius: 21rem;
    display: inline-block;
    text-align: center;
    line-height: 0.42rem;
    font-size: 0.24rem;
    color: #fff;
    position: absolute;
    top: 0.4rem;
    right: 0.34rem;
  }
  .box2 {
    width: 0.9rem;
    height: 0.4rem;
    border-radius: 21rem;
    display: inline-block;
    text-align: center;
    line-height: 0.42rem;
    background: #cccccc;
    border-radius: 0.24rem;
    font-size: 0.24rem;
    color: #ffffff;
    position: absolute;
    top: 0.4rem;
    right: 0.34rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/addaddress.vue